module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp12_5012.ccc22595.png";